import { useEffect, useState } from "react";

import { getPaymentMethod } from "@/services/Auth/AuthApi";
import { BranchPaymentConfigPaymentMethod } from "@/types/authService";

export const usePaymentMethodList = (branchId: number) => {
  const [paymentMethodDetails, setPaymentMethodDetails] =
    useState<BranchPaymentConfigPaymentMethod | null>(null);
  const [isLoadingForPaymentMethod, setIsLoadingForPaymentMethod] = useState(false);
  const fetchCustomerCheck = async (): Promise<void> => {
    setIsLoadingForPaymentMethod(true);
    try {
      const response = await getPaymentMethod({ branch_id: branchId });
      setPaymentMethodDetails(response?.data[0]);
    } catch (error) {
      console.error("error", error);
    } finally {
      setIsLoadingForPaymentMethod(false);
    }
  };

  useEffect(() => {
    if (!branchId) return;
    void fetchCustomerCheck();
  }, [branchId]);
  return { paymentMethodDetails, isLoadingForPaymentMethod };
};
